import CommentaryController from './CommentaryController';

export { CommentaryController };
